var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HtmlAccented } from '../html-elements/module';
import { filterWeeks, getNeededColumnsForHistoryV2 } from '../d3-services/data-with-history.functions';
import { GraphControllerV2 } from './graph-v2';
var CijferV2 = /** @class */ (function (_super) {
    __extends(CijferV2, _super);
    function CijferV2(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        return _this;
    }
    CijferV2.prototype.pre = function () {
        this._addPadding(0, 60, 0, 0);
        this._addMargin(200, 0, 10, 10);
    };
    CijferV2.prototype.init = function () {
        _super.prototype._init.call(this);
        this.html = new HtmlAccented(this);
        this.html.draw();
        if (this.mapping.parameters[0] && this.mapping.parameters[0][0].format == "decimal") {
            this.config.extra.decimal = true;
        }
        this.update(this.data, this.segment, false);
    };
    CijferV2.prototype.prepareData = function (data) {
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping);
        var history = filterWeeks(data, neededColumns);
        this.main.dataStore.setGraph(this.mapping.slug, history);
        return {
            "history": history,
            "latest": data[0],
            "slice": history.slice(0, 8),
        };
    };
    CijferV2.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
        var noRespondents = (this.mapping.parameters[0][2]) ? this.mapping.parameters[0][2]['column'] : '';
        this.html.redraw([data.latest], noRespondents);
    };
    CijferV2.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return CijferV2;
}(GraphControllerV2));
export default CijferV2;
